module.exports = __webpack_public_path__ + "img/circle.0aee1640.svg";